
import React from "react";
import CpntHeader from "./CpntHeader";
import { useNavigate } from "react-router-dom";
import { useKeycloak } from "@react-keycloak/web";
import CpntHeaderBODropDownOptions from "./CpntHeaderBODropDownOptions";
import { resetCompte } from "../redux/slice/compte.slice";
import { useDispatch } from "react-redux";

const CpntHeaderBO: React.FC = () => {

  const navigate = useNavigate();
  const {keycloak} = useKeycloak();
  const dispatch = useDispatch();
  
  const handleDisconnection = async () => {
    navigate("../admin/");
    //await dispatch(clearPanier());
    dispatch(resetCompte());
    keycloak.logout();
  };

  const handleConnection = async () => {
    keycloak?.login({ loginHint: "" });
  };


  return (
    <CpntHeader logout={handleDisconnection} login={handleConnection} menu={<CpntHeaderBODropDownOptions />} accueilPath="../admin/" libelleButtonConnexion="Connexion" >
    </CpntHeader>
  );
}

export default CpntHeaderBO;
